module.exports = "/fonts/vendor/@mdi/materialdesignicons-webfont.woff?a7a0ab37ad0d83f92001ca1b257d81fe";